export default __webpack_public_path__ + "static/amazonFires8-45c3ed0f1ef674129da95c6965ae5f9f.gif";